import './AssessmentStyle.css';

import React, { useCallback, useEffect, useState } from 'react';

import { Header } from '../../shared/headerNavigation/header/Header';
import Modal from '../../shared/modal/Modal';
import { getAssessmentPageTitle } from '../../shared/util/pageTitles';
import { ValidationProvider } from '../validation/ValidationProvider';
import { AssessmentFormContainer } from './AssessmentFormContainer';
import { AssessmentVideoContainer } from './AssessmentVideoContainer';
import { useAssessment } from './useAssessment';

type ModalProps = {
  questionTitle: string;
  modalText?: string | React.ReactNode;
  main?: string | React.ReactNode;
  secondary?: any[];
};

type ModalTextContent = string | React.ReactNode | { main?: React.ReactNode; secondary?: any[] };

function AssessmentInner(props: any) {
  const {
    assessmentValues,
    errorSummary,
    goals,
    pageOptions,
    regionContent,
    repeatAssessment,
    navigateNextPageHandler,
    navigatePrevPageHandler,
    quickNavHandler,
    saveAssessmentValue,
  } = useAssessment(props);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [modalTextContent, setModalTextContent] = useState<ModalTextContent>();
  const [modalQuestionTitle, setModalQuestionTitle] = useState<string>('');

  const modalClickHandler = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  const openModal = useCallback(({ modalText, main, secondary, questionTitle }: ModalProps) => {
    setModalIsOpen(true);
    setModalTextContent(modalText || { main, secondary });
    setModalQuestionTitle(questionTitle);
  }, []);

  return (
    <>
      {modalIsOpen && (
        <Modal
          modalIsOpen={modalIsOpen}
          onModalClose={modalClickHandler}
          modalText={modalTextContent}
          questionTitle={modalQuestionTitle}
        />
      )}
      <div id="main_container" className="assessment">
        <Header
          page="assessment"
          progress={pageOptions.assessmentProgress}
          onNextPage={quickNavHandler}
          showSideDrawer
          type="transparent"
          assessmentPage={getAssessmentPageTitle(pageOptions.currentPage)}
        />

        <AssessmentVideoContainer pageOptions={pageOptions} />

        <AssessmentFormContainer
          errorSummary={errorSummary}
          pageOptions={pageOptions}
          repeatAssessment={repeatAssessment}
          assessmentValues={assessmentValues}
          saveAssessmentValue={saveAssessmentValue}
          openModal={openModal}
          regionContent={regionContent}
          navigateNextPageHandler={navigateNextPageHandler}
          navigatePrevPageHandler={navigatePrevPageHandler}
          goals={goals}
        />
      </div>
    </>
  );
}

export function Assessment(props: any) {
  return (
    <ValidationProvider>
      <AssessmentInner {...props} />
    </ValidationProvider>
  );
}
